// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"47440d18","854":"7daed94c"}[chunkId] + ".chunk.js";
};